import { render, staticRenderFns } from "./ricercaVerbale.vue?vue&type=template&id=18c92cf1"
import script from "./ricercaVerbale.vue?vue&type=script&lang=js"
export * from "./ricercaVerbale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports